import { NavLink, Outlet } from 'react-router-dom';

import { useAuth } from '../../hooks/useAuth';
import { ReticleIcon } from '../../components/primitives';

export default function AdminLayout() {
  const { hasCapability } = useAuth();

  if (!hasCapability('admin')) {
    return (
      <div className="admin-guard">
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 12 }}>
          <div style={{ color: 'var(--neutral-300)' }}>
            <ReticleIcon size={64} stroke={1.1} />
          </div>
          <h2>Admin access required</h2>
          <p style={{ color: 'var(--text-muted)', maxWidth: 420, lineHeight: 1.6 }}>
            This area is reserved for administrators. Sign in with an administrator account, or ask your system
            owner for help.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-shell">
      <aside className="admin-nav">
        <h2>Admin</h2>
        <p>Manage users, devices, locations, and agent credentials.</p>
        <nav>
          <NavLink to="/admin/users" className={({ isActive }) => (isActive ? 'active' : '')}>
            Users
          </NavLink>
          <NavLink to="/admin/devices" className={({ isActive }) => (isActive ? 'active' : '')}>
            Devices
          </NavLink>
          <NavLink to="/admin/agents" className={({ isActive }) => (isActive ? 'active' : '')}>
            Agents
          </NavLink>
          <NavLink to="/admin/locations" className={({ isActive }) => (isActive ? 'active' : '')}>
            Locations
          </NavLink>
        </nav>
      </aside>
      <main className="admin-content">
        <Outlet />
      </main>
    </div>
  );
}
